/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Rights_TitleInputs */

const da_privacy_rights_title = /** @type {(inputs: Privacy_Rights_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dine rettigheder`)
};

/** @type {(inputs: Privacy_Rights_TitleInputs) => LocalizedString} */
const en_privacy_rights_title = da_privacy_rights_title;

/**

* @param {Privacy_Rights_TitleInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const privacy_rights_title = /** @type {((inputs?: Privacy_Rights_TitleInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Rights_TitleInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_rights_title(inputs)
	return /** @type {LocalizedString} */ ("Dine rettigheder")
});